'use client'

import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { reportError } from "@/(front-desk)/utils/functions"
import { handleCMS } from "@/(front-desk)/store"
import Link from "next/link"
import axios from "axios"
import dayjs from "dayjs"
import newsPlaceholder from "@/(front-desk)/assets/images/news-placeholder.png"


export default function News() {

    const dispatch = useDispatch()
    const CMS = useSelector((state) => state.CMS)

    useEffect(() => {
        if (!CMS.homeNews) {
            getNewsList()
        }
    }, [])

    function getNewsList() {
        axios.get('/api/v1/cms/zh_hant/posts?category=cms.news.blogs')
        .then((res) => {
            // console.log('news list success: ', res.data.body.results)
            let list = []
            if (res.data.body.results[0]) {
                list.push(res.data.body.results[0])
            }
            if (res.data.body.results[1]) {
                list.push(res.data.body.results[1])
            }
            if (res.data.body.results[2]) {
                list.push(res.data.body.results[2])
            }
            dispatch(handleCMS.actions.setHomeNews(list))
        })
        .catch((err) => {
            // console.log(err.config?.url, err)
            dispatch(handleCMS.actions.setHomeNews(false))
            reportError(err)
        })
    }

    if (CMS.homeNews) return (
        <div className="item-group">
            { CMS.homeNews?.map((info) => {
                const item = 
                    <Link
                        key={`news-${info.id}`}
                        href={`/news/all/article?id=${info.id}`}
                        className="item"
                    >
                        <div className="thumbnail">
                            <img src={info.contents.hero_image?.file || newsPlaceholder.src} alt="" />
                        </div>
                        <div className="title">{info.contents.subject}</div>
                        { info.display_start_time &&
                            <div className="time">{dayjs(info.display_start_time).format('YYYY.MM.DD')}</div>
                        }
                    </Link>
                return item
            })}
        </div>
    )
}